import script from "./FranchisesList.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchisesList.vue?vue&type=script&setup=true&lang=js"

import "./FranchisesList.vue?vue&type=style&index=0&id=466c4fce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466c4fce"]])

export default __exports__